import VehiclesGroupedReport from "./VehiclesGroupedReport";

export default function VehiclesByUser() {
  return (
    <VehiclesGroupedReport
      title="Vehicles by User"
      subtitle="Active fuel access registrations grouped by the user who created them."
      dimension="user"
      dropdownLabel="User"
      dropdownPlaceholder="All users"
      dropdownApiPath="/members"
    />
  );
}
